import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';

import { http, route, api } from '../common/common';
import Avatar from './menubar/Avatar';
import Navigation from './menubar/Navigation';
import About from './menubar/About';
import AdatosLogo from '../asset/svg/Adatos'

const styles = (theme) => {
    return {
        background: {
            position: 'absolute',
            left: 0,
            bottom: 0,
            top: 0,
            width: '100%',
            height: 48,
            backgroundColor: theme.palette.primary.main,
            overflow: 'visible',
            textAlign: 'center'
        },
        logoContainer: {
            position: 'absolute',
            left: 16,
            top: 6,
            bottom: 6,
        },
        logo: {
            float: 'left',
            height: '100%',
            width: 120,
            fill: theme.palette.primary.displayText,
        },
        logoCustom: {
            float: 'left',
            marginLeft: 16,
            height: '100%',
            fill: theme.palette.primary.displayText,
        },
        rightControlGroup: {
            position: 'absolute',
            right: 16,
            top: 6,
            bottom: 6,
        },
        avatarContainer: {
            float: 'right',
            marginRight: 0,
        },
        navigationContainer: {
            float: 'right',
            marginRight: 8,
        },
        labelContainer: {
            float: 'right',
            marginRight: 8,
            marginTop: 4,
            marginBottom: 4,
            height: 26,
            borderRadius: 20,
            borderColor: theme.palette.primary.displayText,
            borderWidth: 1,
            borderStyle: 'solid',
            cursor: 'pointer',
        },
        label: {
            marginLeft: 16,
            marginRight: 16,
            color: theme.palette.primary.displayText,
            fontSize: 14,
            textTransform: 'uppercase',
            textAlign: 'center',
            lineHeight: '26px',
        },
        spinnerPlaceholder: {
            outline: 'none',
            position: 'absolute',
            width: 60,
            height: 60,
            top: 'calc(50% - 30px)',
            left: 'calc(50% - 30px)',
            textAlign: 'center',
            backgroundColor: 'transparent',
        },
        spinner: {
            color: theme.palette.text.disabled,
        },
    };
}

class Menubar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showSpinner: false,
            showAbout: false,
            showLogo: false,
        };

        this._refMap = {
            navigation: React.createRef(),
        }

        this._cancelToken = http.CancelToken.source();
    }

    componentWillUnmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        const { classes } = this.props;

        return (
            <div>
                <Paper
                    className={classNames(classes.background, this.props.className)}
                    square={true}
                    elevation={2}
                >
                    <div className={classes.logoContainer}>
                        <AdatosLogo
                            className={classes.logo}
                        />
                        {this._renderProfileLogo()}
                    </div>
                    <div className={classes.rightControlGroup}>
                        <div className={classes.avatarContainer}>
                            <Avatar onChange={this._handleAvatarMenu} />
                        </div>
                        <div className={classes.navigationContainer}>
                            <Navigation
                                innerRef={this._refMap.navigation}
                                appList={this.props.appList}
                                onChange={this._handleNavigationMenu}
                            />
                        </div>
                        <div
                            className={classes.labelContainer}
                            onClick={this._handleMimicNavigationClick}
                        >
                            <div className={classes.label}>
                                {this.props.label}
                            </div>
                        </div>
                    </div>
                </Paper>
                <About
                    getAccessCode={this.props.getAccessCode}
                    open={this.state.showAbout}
                    onOk={this._handleAboutOk}
                />
                {this._renderSpinner()}
            </div>
        );
    }

    _renderSpinner = () => {
        const { classes } = this.props;

        return (
            <Modal
                fullWidth={true}
                disableBackdropClick={false}
                disableEscapeKeyDown={true}
                open={this.state.showSpinner}
            >
                <div className={classes.spinnerPlaceholder}>
                    <CircularProgress
                        className={classes.spinner}
                        size={60}
                    />
                </div>
            </Modal>
        );
    }

    _renderProfileLogo = () => {
        const { classes } = this.props;

        const style = {
            visibility: (this.state.showLogo) ? 'visible' : 'hidden',
            marginLeft: (this.state.showLogo) ? classes.logoCustom.marginLeft : 0,
            width: (this.state.showLogo) ? 'auto' : 0,
        };

        return (
            <img
                className={classes.logoCustom}
                style={style}
                src={api.organization() + '/logo?access_code=' + this.props.getAccessCode()}
                alt=''
                onLoad={this._handleLogoSuccess}
            />
        );
    }

    _handleAvatarMenu = (event, value) => {
        switch (value) {
            case 'signout':
                this._requestRevoke();
                break;
            case 'about':
                this.setState({
                    showAbout: true,
                });
                break;
            default:
                break;
        }
    }

    _handleMimicNavigationClick = (event) => {
        event.preventDefault();

        if (this._refMap.navigation) {
            this._refMap.navigation.current.click()
        }
    }

    _handleNavigationMenu = (event, value) => {
        switch (value) {
            case 'viewer':
                route(this, '/main/viewer', '');
                break;
            case 'tasking':
                route(this, '/main/tasking', '');
                break;
            case 'report':
                route(this, '/main/report', '');
                break;
            case 'settings':
                route(this, '/main/settings', '');
                break;
            case 'faq':
                window.open('https:///faq.adatos.com')
                break;
            default:
                break;
        }
    }

    _handleAboutOk = () => {
        this.setState({
            showAbout: false,
        });
    }

    _handleLogoSuccess = (e) => {
        e.preventDefault();

        this.setState({
            showLogo: true,
        });
    }

    _handleLogoError = (e) => {
        e.preventDefault();

        this.setState({
            showLogo: false,
        });
    }

    _requestRevoke = async () => {
        try {
            this.setState({
                showSpinner: true
            });

            await http.post(api.access() + '/revoke', {
                'access_code': this.props.getAccessCode(),
            }, {
                    cancelToken: this._cancelToken.token,
                });

            this.setState({
                showSpinner: false
            });

            this.props.setAccessCode('');
            route(this, '/home', '');
        } catch (error) {
            this.setState({
                showSpinner: false
            });

            if (http.isCancel(error)) {
                return;
            }
        }
    }
}

Menubar.propTypes = {
    getAccessCode: PropTypes.func.isRequired,
    setAccessCode: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    appList: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default withStyles(styles)(Menubar);
